<div class="form" *appNotesAppContext>
  <div class="form-date">{{ notebook?.createdAt | dateFormat:'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="note"
      [style.color]="notebook?.color"
    />
    {{ notebook?.title }}
  </h2>

  @if (notebook) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="notebook"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="notebook"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">
        Parent Notebook
      </div>
      <div class="form-details-row-input">{{ notebook?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Description
      </div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="notebook?.description" />
    </div>
  </div>
</div>
